import { Input } from "antd";

function ProductCategorySearchBar({filter, onSearchChange, onChange, can}) {
	return (
		<div className="p-2">
			<Input.Search
				placeholder="Tìm kiếm theo tên danh mục..."
				allowClear
				onSearch={(value) => onSearchChange({...filter, keyword: value, page: 1})}
				style={{ width: 300 }}
			/>
		</div>
	)
}

export default ProductCategorySearchBar;
